import styled from "styled-components";

export const LayoutContentPromptBox = styled.div`
    width: 100%;
    flex: 1;
    padding: 16px 24px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.silverGrayTwo};
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(106vh - 200px);
`;